import menuTypes from 'common/constants/menuTypes';
import { commonTranslations } from 'translations';

function rootMenu() {
    return {
        i18n: commonTranslations.ng_common_contacts,
        linkTitle: 'Contacts',
        icon: 'onsolve-contacts-icon',
        routeTo: '/contacts',
        isRenderable: true,
        children: subMenu(),
        menuType: menuTypes.secondary,
        newNav: true,
        accessConfiguration: permissions => permissions.canViewContacts() || permissions.canViewGroups()
    };
}

function subMenu() {
    return [
        {
            i18n: commonTranslations.ng_common_groups,
            linkTitle: 'Groups',
            routeTo: '/groups',
            isEnabled: true,
            isGroupAccessRequired: true,
            isRenderable: true,
            newNav: true,
            accessConfiguration: permissions => {
                return permissions.canViewGroups();
            }
        }
    ];
}

export default rootMenu;
